import type { BillingLine } from "../../shared/billing-schemas";
import { cadenceLabel, describeDiscount, formatUsd } from "./billing-format";

/** The lines table of a quote or a terms version: a quote's lines are the terms' lines to be. */
export function Lines({ terms }: { terms: { title: string; lines: BillingLine[] } }) {
  return (
    <div className="overflow-x-auto">
      <table
        className="w-full min-w-md border-collapse text-left text-sm"
        aria-label={`Lines of ${terms.title}`}
      >
        <thead>
          <tr className="border-b text-xs text-muted-foreground">
            <th className="py-1 pr-2 font-semibold">Line</th>
            <th className="py-1 pr-2 font-semibold">Unit</th>
            <th className="py-1 pr-2 font-semibold">Qty</th>
            <th className="py-1 pr-2 font-semibold">Discount</th>
            <th className="py-1 font-semibold">Total</th>
          </tr>
        </thead>
        <tbody>
          {terms.lines.map((line) => (
            <tr key={line.id} className="border-b last:border-b-0">
              <td className="py-1 pr-2">
                {line.description}
                <span className="ml-1 text-xs text-muted-foreground">
                  {line.kind === "credit" ? "credit" : cadenceLabel(line.cadence)}
                </span>
              </td>
              <td className="py-1 pr-2">{formatUsd(line.unitAmountMinor)}</td>
              <td className="py-1 pr-2">{line.quantity}</td>
              <td className="py-1 pr-2">{describeDiscount(line.discount) || "—"}</td>
              <td className="py-1 font-semibold">{formatUsd(line.totalMinor)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
